import { AxiosConfig } from '../../componentes/axiosConfig';

export class ExibirPaginaComando {
    constructor() {
        this._axios                    = (new AxiosConfig()).instanciaAxios();
        this._classExibirPaginaComando = 'exibir-pagina-comando';
        this._idDivConteudoModal       = 'conteudo-modal';
    }

    executar() {
        const btnExibirPaginaComando = $(`.${this._classExibirPaginaComando}`);
        if (btnExibirPaginaComando.length === 0) {
            return;
        }

        const _this = this;
        btnExibirPaginaComando.on('click', function (evento) {
            evento.preventDefault();
            _this._exibirPaginaComando($(this).attr('href'));
        });
    }

    _exibirPaginaComando(urlRequisicao) {
        this._axios.get(urlRequisicao)
        .then((response) => {
            $(`#${this._idDivConteudoModal}`).html(
                $(response.data).find('#pagina-comando').html()
            );

            $('#modal-tela-envio-comando').modal();
            $('[data-toggle="tooltip"]').tooltip();
        })
        .catch((error) => {
            console.log(error);
        });
    }
}
